<div *ngIf="ready">
    <div class="cmn-flex row align-baseline padded-top-lg" *ngIf="!isCustomTag(tag)">
        <mat-form-field class="flex">
            <mat-placeholder>Name</mat-placeholder>
            <input [(ngModel)]="tag.name" matInput required maxlength="256">
        </mat-form-field>
        <mat-checkbox [(ngModel)]="tag.required" class="padded-left-lg">Required</mat-checkbox>
    </div>
    <div class="cmn-flex row space-between" *ngIf="isCustomTag(tag)">
        <h2 mat-dialog-title>Tag: {{tag.name}}</h2>
        <mat-checkbox [(ngModel)]="tag.required">Required</mat-checkbox>
    </div>
    <div *ngIf="!isCustomTag(tag)">
        <mat-radio-group [(ngModel)]="tag.input_type" class="cmn-flex row space-between">
            <mat-radio-button (click)="addOptions()" [value]="DROPDOWN">Dropdown</mat-radio-button>
            <mat-radio-button (click)="addOptions()" [value]="RADIO">Radio Buttons</mat-radio-button>
            <mat-radio-button (click)="removeOptions()" [value]="TEXTBOX">Text Box</mat-radio-button>
            <mat-radio-button (click)="removeOptions()" [value]="TEXTAREA">Text Area</mat-radio-button>
        </mat-radio-group>
        <mat-form-field class="full-width spaced-top" *ngIf="optionsDisabled()">
            <mat-placeholder>Prompt</mat-placeholder>
            <input [(ngModel)]="tag.prompt" matInput required maxlength="256">
            <mat-error>Please enter a valid prompt</mat-error>
        </mat-form-field>
        <mat-form-field class="full-width spaced-top" *ngIf="!optionsDisabled()">
            <mat-placeholder>Prompt</mat-placeholder>
            <input [(ngModel)]="tag.prompt" matInput maxlength="256">
            <mat-error>Please enter a valid prompt</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="optionsDisabled()" class="full-width">
            <mat-placeholder>Options (In Comma Seperated Value Form)</mat-placeholder>
            <input [(ngModel)]="tag.tag_options" matInput required maxlength="1000">
            <mat-error>Please enter at least one value.</mat-error>
        </mat-form-field>
    </div>
    <div>
        <h2 mat-dialog-title class="spaced-top">Preview</h2>
        <mat-card>
            <div [ngSwitch]="tag.input_type">
                <mat-form-field *ngSwitchCase="'APPLICATIONS'" class="cmn-flex flex full-width"
                                matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                    <mat-chip-list #chipListApp [(ngModel)]="appList">
                        <mat-chip (removed)="removeApp(application)" *ngFor="let application of appList">
                            {{application}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input #applicationInput (blur)="appFieldBlur($event, applicationInput)"
                               (matChipInputTokenEnd)="addApp($event, applicationInput)"
                               (ngModelChange)="applicationChange.next($event)"
                               [(ngModel)]="selectedAppName"
                               [matAutocomplete]="acApplication"
                               [matChipInputFor]="chipListApp"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               name="appInputCtrl"
                               id="applicationField" matInput>
                    </mat-chip-list>
                    <mat-hint>Please enter a ServiceNow application name</mat-hint>
                    <mat-placeholder>application</mat-placeholder>
                    <mat-autocomplete #acApplication="matAutocomplete"
                                      (optionSelected)="addApp($event.option.value, applicationInput)"
                                      [displayWith]="getAppName" id="appAutocomplete">
                        <mat-option *ngFor="let application of applications"
                                    [value]="application">
                            {{application.application_name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field *ngSwitchCase="'CLIENTS'" class="cmn-flex flex full-width"
                                matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                    <mat-chip-list #chipListClient [(ngModel)]="clientsImpacted">
                        <mat-chip (removed)="removeClient(client)" *ngFor="let client of clientsImpacted">
                            {{client}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input #clientInput
                               (blur)="clientFieldBlur($event, clientInput)"
                               (matChipInputTokenEnd)="addClient($event, clientInput)"
                               (ngModelChange)="clientChange.next($event)"
                               [(ngModel)]="currentClient"
                               [matAutocomplete]="autoClient" [matChipInputFor]="chipListClient"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               id="clientField" matInput name="clientInputCtrl">
                    </mat-chip-list>
                    <mat-hint>Please enter a ServiceNow client name</mat-hint>
                    <mat-placeholder>client</mat-placeholder>
                    <mat-autocomplete #autoClient="matAutocomplete"
                                      (optionSelected)="addClient($event.option.value, clientInput)"
                                      [displayWith]="getClientName" id="clientAutocomplete">
                        <mat-option *ngFor="let client of clients"
                                    [value]="client">{{client.client_name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field *ngSwitchCase="'DATE'" class="cmn-flex flex full-width"
                                matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                    <input [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" matInput>
                    <mat-placeholder>Choose a date
                        <mat-icon>event</mat-icon>
                    </mat-placeholder>
                    <mat-hint>Tag {{'{{' + tag.name + '\}\}'}}</mat-hint>
                    <owl-date-time #dtPicker></owl-date-time>
                </mat-form-field>
                <mat-form-field *ngSwitchCase="'SENTBY'" class="cmn-flex flex full-width">
                    <input (ngModelChange)="senderChange.next($event)" [(ngModel)]="sentBy" [matAutocomplete]="acSender"
                           name="sentCtrl" [required]="tag.required" matInput>
                    <mat-hint>Tag {{'{{' + tag.name + '\}\}'}}</mat-hint>
                    <mat-placeholder>Please enter an Individual's name</mat-placeholder>
                    <mat-autocomplete #acSender="matAutocomplete">
                        <mat-option *ngFor="let sender of senders" [value]="sender.full_name">
                            {{sender.full_name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field *ngSwitchCase="'DROPDOWN'" class="full-width">
                    <mat-select [required]="tag.required">
                        <mat-option *ngFor="let option of tag.tag_options.split(',')" [value]="option.trim()">
                            {{option.trim()}}
                        </mat-option>
                    </mat-select>
                    <mat-hint>{{tag.name}}</mat-hint>
                    <mat-label>{{tag.prompt}}</mat-label>
                </mat-form-field>
                <div *ngSwitchCase="'RADIO'" class="cmn-flex row gutters">
                    <mat-label>{{tag.prompt}}<span *ngIf="tag.required">*</span></mat-label>
                    <mat-radio-group class="cmn-flex row gutters">
                        <mat-radio-button *ngFor="let option of tag.tag_options.split(',')" [value]="option.trim()">
                            {{option.trim()}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <mat-form-field *ngSwitchCase="'TEXTBOX'" class="full-width">
                    <input [name]="tag.name" [required]="tag.required" matInput>
                    <mat-hint>{{tag.name}}</mat-hint>
                    <mat-label>{{tag.prompt}}</mat-label>
                </mat-form-field>
                <mat-form-field *ngSwitchDefault class="full-width">
                    <textarea [name]="tag.name" [required]="tag.required" matInput></textarea>
                    <mat-placeholder>{{tag.prompt}}</mat-placeholder>
                    <mat-hint>Tag {{'{' + tag.name + '}'}}</mat-hint>
                </mat-form-field>
            </div>
        </mat-card>
    </div>
</div>
<mat-dialog-actions class="cmn-flex row space-between">
    <button [mat-dialog-close]="this.tag" [disabled]="!isValid()" color="primary" mat-raised-button>Save</button>
    <button [mat-dialog-close]="false" color="primary" mat-raised-button>Cancel</button>
</mat-dialog-actions>

